import { render, staticRenderFns } from "./OfferRevenueUpsertRow.vue?vue&type=template&id=dbf73532&scoped=true"
import script from "./OfferRevenueUpsertRow.vue?vue&type=script&lang=js"
export * from "./OfferRevenueUpsertRow.vue?vue&type=script&lang=js"
import style0 from "./OfferRevenueUpsertRow.vue?vue&type=style&index=0&id=dbf73532&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf73532",
  null
  
)

export default component.exports